import { DocumentId, EndpointQueryParameters } from '../../../../../../types/strapi/strapi'
import {
    materialRequirementsPopulate,
    shipmentAvailabilityPopulate,
    shipmentPeoplePopulate,
} from '../../../constants/shipment-populate'
import getCreatedPrintJobsFilters from './get-created-print-jobs-filters'

const listQueryParams: EndpointQueryParameters = {
    sort: ['shipment.clientDeliveryDate:asc'],
    populate: {
        shipment: {
            populate: {
                ...shipmentAvailabilityPopulate,
                ...shipmentPeoplePopulate,
                client: true,
                shipment_positions: true,
                machine: true,
                additional_machines: true,
                materialRequirements: { populate: materialRequirementsPopulate },
                calculated: true,
                calculatedOnActual: true,
            },
        },
    },
}

export default function getCreatedPrintJobsListQueryParams(
    machineDocIds: DocumentId[]
): EndpointQueryParameters {
    return {
        ...listQueryParams,
        filters: getCreatedPrintJobsFilters(machineDocIds),
    }
}
